import React, { useEffect } from 'react';
import env from '@environment';
import { useLocale } from '@app/core/hooks/useLocale';
import { StatusPage } from '@app/shared/components/status-pages/StatusPage';
import { useAppDispatch } from '@app/core/hooks/redux-hooks';
import { logout } from '@app/core/store/user-info.slice';

export const Logout: React.FC = () => {
  const { l } = useLocale();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return (
    <StatusPage>
      <h2>{l('_SuccessfulLogout')}</h2>
      <p>{l('_CloseBrowserWindow')}</p>
      <br />
      <p>
        {l('_IncorrectLogout')}
        <a href={`${env.apiUrl}/account/login?redirectUri=${document.baseURI}`}>
          {l('_LoginAgain')}
        </a>
      </p>
    </StatusPage>
  );
};
